import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-seller-card-skeleton',
  templateUrl: './seller-card-skeleton.component.html',
  styleUrls: ['./seller-card-skeleton.component.scss'],
  standalone: false
})
export class SellerCardSkeletonComponent {
  @Input() count: number = 3;

  get items(): number[] {
    return Array.from({ length: this.count }, (_, i) => i);
  }
}
